module.exports = "img/flags/GY.1313a7c.png";